import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import f, { createContext as M, useContext as d, useState as H } from "react";
import { Hidden as E, HiddenFeatures as T } from '../internal/hidden.js';
import { getOwnerDocument as L } from '../utils/owner.js';
import { useEvent as s } from './use-event.js';
import { useOwnerDocument as h } from './use-owner.js';
function R() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$defaultContainer = _ref.defaultContainers,
    l = _ref$defaultContainer === void 0 ? [] : _ref$defaultContainer,
    n = _ref.portals,
    o = _ref.mainTreeNode;
  var r = h(o),
    u = s(function () {
      var i, c;
      var t = [];
      var _iterator = _createForOfIteratorHelper(l),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          _e !== null && (_e instanceof HTMLElement ? t.push(_e) : "current" in _e && _e.current instanceof HTMLElement && t.push(_e.current));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (n != null && n.current) {
        var _iterator2 = _createForOfIteratorHelper(n.current),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var e = _step2.value;
            t.push(e);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var _iterator3 = _createForOfIteratorHelper((i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : []),
        _step3;
      try {
        var _loop = function _loop() {
          var e = _step3.value;
          e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (o && (e.contains(o) || e.contains((c = o == null ? void 0 : o.getRootNode()) == null ? void 0 : c.host)) || t.some(function (m) {
            return e.contains(m);
          }) || t.push(e));
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return t;
    });
  return {
    resolveContainers: u,
    contains: s(function (t) {
      return u().some(function (i) {
        return i.contains(t);
      });
    })
  };
}
var a = M(null);
function O(_ref2) {
  var l = _ref2.children,
    n = _ref2.node;
  var _H = H(null),
    _H2 = _slicedToArray(_H, 2),
    o = _H2[0],
    r = _H2[1],
    u = b(n != null ? n : o);
  return f.createElement(a.Provider, {
    value: u
  }, l, u === null && f.createElement(E, {
    features: T.Hidden,
    ref: function ref(t) {
      var i, c;
      if (t) {
        var _iterator4 = _createForOfIteratorHelper((c = (i = L(t)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? c : []),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var e = _step4.value;
            if (e !== document.body && e !== document.head && e instanceof HTMLElement && e != null && e.contains(t)) {
              r(e);
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }));
}
function b() {
  var l = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var n;
  return (n = d(a)) != null ? n : l;
}
export { O as MainTreeProvider, b as useMainTreeNode, R as useRootContainers };